import i18next, {ResourceLanguage} from 'i18next';
import {initReactI18next} from 'react-i18next';
import * as zod from 'zod-i18n-map/locales/fr/zod.json';

import translation from './fr/translation.json';
const APP_ENV = import.meta.env.VITE_APP_ENV.toUpperCase();

function addPrefixToDocumentTitles(data: ResourceLanguage, prefix: string, suffix: string): void {
  Object.keys(data).forEach((key) => {
    if (key === 'suffix') {
      return;
    }
    if (typeof data[key] === 'string') {
      data[key] = `${prefix}${data[key]}${key === 'default' ? '' : suffix}`;
    } else {
      addPrefixToDocumentTitles(data[key] as ResourceLanguage, prefix, suffix);
    }
  });
}

if (APP_ENV !== 'PROD') {
  addPrefixToDocumentTitles(translation.documentTitle as ResourceLanguage, '🚧 ', translation.documentTitle.suffix);
}

i18next.use(initReactI18next).init({
  lng: 'fr', // if you're using a language detector, do not define the lng option
  debug: ['DEV', 'LOCAL'].includes(APP_ENV),
  resources: {
    fr: {
      translation,
      zod,
    },
  },
  defaultNS: 'translation',
});
export default i18next;
